import { type Sort2 as Sort } from '@innovyze/lib-am-common';
import { type GridInitialState } from '@innovyze/stylovyze';
import { type MenuItemProps } from '@mui/material';
import { type AnyAction } from 'redux';

// This is a for MenuListButton AND DropDownButton, hence the text AND name
export interface Option {
	icon?: React.ReactNode;
	text: string;
	name: string;
	onClick: () => void;
	cy?: string;
	key?: number;
	props?: MenuItemProps;
}

export interface DefectCode {
	code: string;
	desc: string;
}

export interface UtilStoreState {
	search: string;
	dataGridState: { [key: string]: GridInitialState | undefined };
	selectedUniqueIds: string[];
	selectedUniqueStatus: string;
}

export interface UtilReducer {
	[x: string]: (
		state: UtilStoreState,
		action: AnyAction,
	) => UtilStoreState | undefined;
}

export const utilStoreStateInitial = (): UtilStoreState => ({
	search: '',
	dataGridState: {},
	selectedUniqueIds: [],
	selectedUniqueStatus: '',
});

export interface PaginationChange {
	action: number | Sort | string;
}
